var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpperGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 71,
    viewBox: "0 0 74 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:rgba(245,250,255,0.53);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 74,
    height: 71
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-324 -163)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-269 -163)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-324 -144)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-269 -144)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-324 -125)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-269 -125)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-324 -106)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-269 -106)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperGrid);
export default __webpack_public_path__ + "static/media/upper_grid.c075306c92fd34f42600a1991e4b7adb.svg";
export { ForwardRef as ReactComponent };